import React, { useLayoutEffect } from "react";
import Iframe from "../../components/reusable/iframe/Iframe";
import { Button } from "@mui/material";
const Index = ({ setIsTermsAndConditions }) => {
  return (
    <div style={{ width: "100%", height: "100vh" }} className="bg-black">
      <Button
        size="small"
        variant="contained"
        disableRipple
        onClick={() => setIsTermsAndConditions(false)}
        sx={{
            float: "right",
          marginTop: "20px",
          marginBottom: "20px",
          paddingTop: "5px",
          paddingBottom: "5px",
            marginRight: "10px",
          borderTopLeftRadius: "50px", // Adjust the radius value as needed
          borderBottomLeftRadius: "50px", // Adjust the radius value as needed
          borderTopRightRadius: "50px", // No rounding on the right-top corner
          borderBottomRightRadius: "50px", // No rounding on the right-bottom corner
          backgroundColor: "#facc15",
          color: "black",
          "&:hover": {
            backgroundColor: "#eab308",
            borderColor: "#eab308",
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
            backgroundColor: "#facc15",
            borderColor: "#ca8a04",
          },
        }}
      >
        X
      </Button>
      <Iframe
        src="https://s3.ap-southeast-1.amazonaws.com/data.bitmyanmar.info/sns/miniapp/snsmini_tc.html" // Replace with your API endpoint
        title="Terms and Conditions"
        width="100%"
        height="100%"
      />

      <div className="flex items-center justify-center">
        <Button
          size="small"
          variant="contained"
          disableRipple
          onClick={() => setIsTermsAndConditions(false)}
          sx={{
            marginTop: "20px",
            marginBottom: "20px",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingRight: "10px",
            paddingLeft: "10px",
            borderTopLeftRadius: "50px", // Adjust the radius value as needed
            borderBottomLeftRadius: "50px", // Adjust the radius value as needed
            borderTopRightRadius: "50px", // No rounding on the right-top corner
            borderBottomRightRadius: "50px", // No rounding on the right-bottom corner
            backgroundColor: "#facc15",
            color: "black",
            "&:hover": {
              backgroundColor: "#eab308",
              borderColor: "#eab308",
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: "#facc15",
              borderColor: "#ca8a04",
            },
          }}
        >
          နားလည်သဘောတူပါသည်။
        </Button>
      </div>
    </div>
  );
};

export default Index;
